/* eslint-disable import/extensions */
import('./bootstrap.jsx');
